import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class OpenPunchListService {

  private baseurl = "";
  private apiroute = "";

  constructor(
    private http: HttpClient,
    private appSetting: AppConfigService,
  ) {
    this.baseurl = this.appSetting.apiBaseUrl;
    this.apiroute = '/FlexIntegration';
  }

  InsertUpdateOpenItem(servicesiteid, name, dateex, responsible, itemreviewed, datereview, itemclosed, dateclosed, notes ){
    let obj = {
      method: 'SavePunchItempProjectCe',
      // servicesiteid: servicesiteid,
      projectid: servicesiteid,
      name: name,
      dateex: dateex,
      responsible: responsible,
      itemclosed: itemclosed,
      dateclosed: dateclosed,
      notes: notes,
      itemreviewed: itemreviewed,
      datereview: datereview,
      id: 0,
    }
    console.log(obj)
    return this.http.post<any>(this.baseurl + '/FlexIntegration', obj);
  }

  GetPunchList(idProject){
    return this.http.post<any>(this.baseurl + '/FlexIntegration', {method:'Get_OpenPunchListItemAllByProjectId', numProjectID:idProject});
    // return this.http.post<any>(this.baseurl + this.apiroute, {method:'Get_OpenPunchListItemAll', Projected:idProject})
  }

  UpdatePunchList(taskid, projectid, userid, name, dateex, responsible, itemclosed, dateclosed, notes, itemreviewed, datereview  ){
    let obj = {
      method: 'SavePunchItempProjectCe',
      name: name,
      dateex: dateex,
      responsible: responsible,
      itemclosed: itemclosed,
      dateclosed: itemclosed ? dateclosed : null,
      notes: notes,
      itemreviewed: itemreviewed,
      datereview:itemreviewed ? datereview : null,
      projectid: projectid,
      id: taskid,
    }
    console.log(obj);
    return this.http.post<any>(this.baseurl + this.apiroute, obj);
  }

  GetPunchListByID(id){
    return this.http.post<any>(this.baseurl + this.apiroute, {method:'Get_OpenPunchListItemById', itemid: id });
  }

  //Documents Punch List

  InsertDocument(form){
    console.log(form);
    return this.http.post<any>(this.baseurl + this.apiroute, form);
  }

  DeleteDocument(id){
    return this.http.post<any>(this.baseurl + '/ServiceSitePunch', {method:'DeleteOpenItemAttachment', Opeitemid: id });
  }

  GetDocuments(id){
    let obj = {method:'GetPunchItemsAttachment', punchitemid: id}
    return this.http.post<any>(this.baseurl + this.apiroute, obj);
  }

  SaveDocumentDinamico(file, id,doctype){
    console.log({filestring: file, doctype: doctype, id: id })
    return this.http.post(this.baseurl + '/DownloadFile/Upload', { filestring: file, doctype: doctype, id: id })
  }

}
